module.exports = __webpack_public_path__ + "static/2-f91b6927fd1c6e4e83fcb20d6bdf1837.jpg";